// extracted by mini-css-extract-plugin
export default {"product-card__image":"ProductCard_product-card__image__mkhVU"};